/* eslint-disable max-len */
import { useEffect }from 'react';
import { OrgLanding } from '../OrgLanding/index';
import { SignInProxy } from '../SignIn';
import { DataProvider } from '../AppContext';
import { Route, Routes } from 'react-router-dom';
import { TwoFactorAuth } from '../TwoFactorAuthentication';
import { ForgotPasswordProxy } from '../ForgotPassword/ForgotPassword';
import { NoRouteMatchedproxy } from './noRouteMatch';
import { ResetPassword } from '../ResetPassword-Contained/ResetPasswordContainer';
import { SetSecurityQuestions } from '../UserActivation-Contained/SetSecurityQuestions';
import { MobileAccessPage } from '../UserActivation-Contained/MobileAccessPage';
import { MobileSignUpPage } from '../UserActivation-Contained/MobileSignUpPage';
import { FIRST_INDEX } from '../../utilities/constants';
import { OAuthLanding } from '../AuthLanding/OAuthLanding';
import { KeycloakLanding } from '../AuthLanding/KeycloakLanding';
import { UserActivationFlow } from '../UserActivationFlow/UserActivationFlow';
import { UserActivationContainer } from '../UserActivation-Contained/UserActivationContainer';
import ErrorPage from './errorPage';
// eslint-disable-next-line max-statements
const metaTagForDeviceWidth = ( ) => {
  const metaTag = document.getElementsByTagName('META');
  for (let i=0; i<metaTag.length; i++) {
    if (metaTag[i].getAttribute('name') === 'viewport') {
      const meta = ( ( ( metaTag[i])));
      const body = document.getElementsByTagName('body');
      if(
        (window.location.pathname === '/sign-in') ||
          (window.location.pathname === '/forgot-password') ||
          (window.location.pathname === '/reset-password') ||
          (window.location.pathname === '/twoFactorAuth') ||
          ( window.location.pathname === '/')
      ) {
        meta.content =
            'width=device-width, initial-scale=1, shrink-to-fit=no';
        body[FIRST_INDEX].classList.add('responsive');
      } else if(
        (window.location.pathname === '/user-activation')
      ) {
        meta.content =
            'name="viewport" content="width=device-width, initial-scale=1.0';
        document.getElementById('root').classList.add('responsiveContainer');
      } else {
        meta.content =
            'width=1440, initial-scale=1, shrink-to-fit=no';
        body[FIRST_INDEX].classList.remove('responsive');
      }
    }
  }
};

export const Home = () => {
  useEffect(() => {
    metaTagForDeviceWidth();
  }, []);
  return (
    <div>
      <DataProvider>
        <Routes>
          <Route path='/' element={<OrgLanding/>} />
          <Route path='/sign-in' element={<SignInProxy/>}/>
          <Route path='/twoFactorAuth' element={<TwoFactorAuth/>}/>
          <Route path='/forgot-password' element={<ForgotPasswordProxy/>}/>
          <Route path='/reset-password' element={<ResetPassword/>}/>
          <Route path='/user-activation' element={<UserActivationContainer/>}/>
          <Route path='/user-activation-new' element={<UserActivationFlow/>}/>
          <Route path='/setSecurityQues' element={<SetSecurityQuestions/>}/>
          <Route path='/mobileUnlock' element={<MobileAccessPage/>}/>
          <Route path='/auth-sign-in' element={<OAuthLanding/>}/>
          <Route path='/keycloak-sign-in' element={<KeycloakLanding/>}/>
          <Route path='/deep-link' element={<MobileSignUpPage/>}/>
          <Route path='/error' element={<ErrorPage/>}/>
          <Route path='*' element={<NoRouteMatchedproxy/>}/>
        </Routes>
      </DataProvider>
    </div>
  );
};
